<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Aneksy'" [name]="'Lista'"></app-breadcrumb>
<div class="annex-configuration-list-container" fxLayout="column" fxLayoutGap="15px">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm">
    <mat-form-field style="display: none" class="annex-configuration-list-filter">
      <mat-label>UUID</mat-label>
      <input matInput placeholder="UUID" name="uuid" [(ngModel)]="initialFilters.uuid">
    </mat-form-field>

    <mat-form-field appearance="standard" class="annex-configuration-list-filter">
      <mat-label>ID</mat-label>
      <input matInput placeholder="ID" name="recordId" [(ngModel)]="initialFilters.recordId">
    </mat-form-field>

    <app-dict-partners
      [multiple]="false" [label]="'Partner'"
      class="annex-configuration-list-filter"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <app-dict-ofwcas
      [multiple]="false" label="OFWCA"
      class="annex-configuration-list-filter"
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
    ></app-dict-ofwcas>

    <app-dict-insurance-companies
      (selectedInsuranceCompanies)="selectedInsuranceCompanies = $event"
      [multiple]="true" label="TU" class="annex-configuration-list-filter"
      [(ngModel)]="initialFilters.in$insuranceCompany"
      name="in$insuranceCompany"
    ></app-dict-insurance-companies>

    <app-dict
      [multiple]="true" label="Importer"
      class="annex-configuration-list-filter"
      [dictType]="'commission_importer_' + (selectedInsuranceCompanies?.length > 0 ? selectedInsuranceCompanies[0].key : '')"
      [(ngModel)]="initialFilters.in$importer" name="in$importer"
    ></app-dict>

    <app-dict-risk-dicts
      label="Słownik ryzyk"
      class="annex-configuration-list-filter"
      [required]="false"
      [insuranceCompanyId]="selectedInsuranceCompanies[0]?.id"
      [(ngModel)]="initialFilters.riskDictionaryName"  name="riskDictionaryName"
    ></app-dict-risk-dicts>

    <app-dict
      [multiple]="true"
      label="Ryzyko ASF" class="annex-configuration-list-filter"
      dictType="internal_risk"
      [(ngModel)]="initialFilters.in$internalRisk" name="in$internalRisk"
    ></app-dict>

    <mat-form-field appearance="standard" class="annex-configuration-list-filter">
      <mat-label>Archiwum</mat-label>
      <mat-select [(ngModel)]="initialFilters.archive" name="archive">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard" class="annex-configuration-list-filter">
      <mat-label>Aneks poprawny</mat-label>
      <mat-select [(ngModel)]="initialFilters.valid" name="valid">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard" class="annex-configuration-list-filter">
      <mat-label>Przepięcie Ofwca</mat-label>
      <mat-select [(ngModel)]="initialFilters.overvoltage" name="overvoltage">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <app-datepicker
      class="annex-configuration-list-filter "
      label="Data zawarcia polisy od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$activePolicyFrom" name="gte$activePolicyFrom"
    ></app-datepicker>

    <app-datepicker
      class="annex-configuration-list-filter"
      label="Data zawarcia polisy do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$activePolicyTo" name="lte$activePolicyTo"
    ></app-datepicker>

    <mat-form-field appearance="standard" class="annex-configuration-list-filter">
      <mat-label>Standard 2025</mat-label>
      <mat-select [(ngModel)]="initialFilters.standard2025" name="standard2025">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard" class="annex-configuration-list-filter">
      <mat-label>Standard 2026</mat-label>
      <mat-select [(ngModel)]="initialFilters.standard2026" name="standard2026">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>


    <mat-form-field appearance="standard" class="annex-configuration-list-filter">
      <mat-label>Prowizja niestandardowa</mat-label>
      <mat-select [(ngModel)]="initialFilters.customCommission" name="customCommission">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

  </form>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="center center">
      <button *ngIf="(userPermissions | async).settlement.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).settlement.read_report"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>

  <div fxLayout="column" fxFlex="100">
    <table mat-table [dataSource]="items" multiTemplateDataRows>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> ID </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          {{element.recordId}}
        </td>
      </ng-container>

      <ng-container matColumnDef="partner">
        <th mat-header-cell *matHeaderCellDef> Partner </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          <ng-container *ngIf="element.partner && !element.overvoltage">
            <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{element.partner?.shortName}}</a>
          </ng-container>
          <ng-container *ngIf="element.partner && element.overvoltage">
            <a matBadge="P" matBadgeColor="primary" matBadgeOverlap="false" matBadgeSize="small" class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{element.partner?.shortName}}</a>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="ofwca">
        <th mat-header-cell *matHeaderCellDef> OFWCA </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          <ng-container *ngIf="element.ofwca">
            <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">{{element.ofwca.fullName}}</a>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="insuranceCompany">
        <th mat-header-cell *matHeaderCellDef> TU </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          <a class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">
            {{element.insuranceCompany.name}}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="importer">
        <th mat-header-cell *matHeaderCellDef> Importer </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          {{element.importer?.name}}
        </td>
      </ng-container>

      <ng-container matColumnDef="internalRisk">
        <th mat-header-cell *matHeaderCellDef> Ryzyko ASF </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          {{element.internalRisk?.name}}
        </td>
      </ng-container>

      <ng-container matColumnDef="customerName">
        <th mat-header-cell *matHeaderCellDef> Nazwa klienta </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          {{element.customerName}}
        </td>
      </ng-container>

      <ng-container matColumnDef="policyNumber">
        <th mat-header-cell *matHeaderCellDef> Numer polisy </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          {{element.policyNumber}}
        </td>
      </ng-container>

      <ng-container matColumnDef="ratePaid">
        <th mat-header-cell *matHeaderCellDef> Stawka % Partner </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          <mat-chip-list *ngIf="element.ratePaid">
            <mat-chip class="green-mat-chip" selected>{{element.ratePaid}}</mat-chip>
          </mat-chip-list>
        </td>
      </ng-container>

      <ng-container matColumnDef="policyTypes">
        <th mat-header-cell *matHeaderCellDef> Typ polisy </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          <ng-container *ngFor="let policyType of element.policyTypes">
            {{policyType.name}}<br>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="activeFrom">
        <th mat-header-cell *matHeaderCellDef> Data od</th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          {{element.activeFrom | date:'y-MM-dd'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="activeTo">
        <th mat-header-cell *matHeaderCellDef> Data do</th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          {{element.activeTo | date:'y-MM-dd'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="archive">
        <th mat-header-cell *matHeaderCellDef> Archiwum </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          {{element.archive ? 'Tak' : 'Nie'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="valid">
        <th mat-header-cell *matHeaderCellDef> Poprawny </th>
        <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
          {{element.valid ? 'Tak' : 'Nie'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-icon-button
            (click)="clone(element)"
            [disabled]="!(userPermissions | async).settlement.write"
            color="accent"
          ><mat-icon>content_copy</mat-icon></button>
          <button
            mat-icon-button
            *ngIf="!element.overvoltage"
            (click)="cloneAnnexes(element)"
            [disabled]="!(userPermissions | async).settlement.write"
            color="accent"
          ><mat-icon>folder_copy</mat-icon></button>
          <button
            mat-icon-button
            (click)="edit(element, false)"
            [disabled]="!(userPermissions | async).settlement.write"
            color="accent"
          ><mat-icon>edit</mat-icon></button>
          <button
            [disabled]="!(userPermissions | async).settlement.delete"
            mat-icon-button
            (click)="delete(element)"
            color="warn"
          ><mat-icon>delete</mat-icon></button>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="expanded-row-td">
          <div class="expanded-data" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
            <div fxFlex="100" *ngIf="element == expandedElement">
              <app-annex-group-view
                [annex]="element"
                (modifyClicked)="modify = true"
                *ngIf="!modify"
                fxFlex="100"
              ></app-annex-group-view>
              <app-annex-group-form
                [annex]="element"
                (closeModification)="modify = false; modificationClosed()"
                *ngIf="modify"
                fxFlex="100"
              ></app-annex-group-form>
            </div>

          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        class="table-row"
        mat-row *matRowDef="let element; let row; columns: displayedColumns;"
        [class.expanded-row]="expandedElement === element"
        [class.not-expanded-row]="expandedElement && expandedElement !== element"
        [ngClass]="{'overvoltage': element.overvoltage}"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" [ngClass]="{'overvoltageDisable': row.overvoltage}" class="expanded-data-row"></tr>
    </table>

    <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>

</div>
